export function getStyleBlock({ id, style }) {
	if (
		!Array.isArray(style.styleblocks) &&
		style.styleblocks !== null &&
		style.styleblocks !== undefined &&
		typeof style.styleblocks === 'object'
	) {
		const styleblocks = [];
		for (const i in style.styleblocks) {
			styleblocks.push(style.styleblocks[i]);
		}
		style.styleblocks = styleblocks;
	}
	if (style.styleblocks && Array.isArray(style.styleblocks)) {
		for (let styleblock of style.styleblocks) {
			if (styleblock.id === id) {
				return styleblock;
			}
		}
	}

	return null;
}

export function getComponentMargin({ component, style }) {
	const margin = {
		marginBottom: 0,
		marginTop: 0,
		marginLeft: 0,
		marginRight: 0,
	};
	try {
		const canvas = style['canvas'];
		switch (component.component) {
			case 'image':
			case 'video':
			case 'gallery':
			case 'map':
				if (canvas['component_bottom_margin']) {
					margin.marginBottom = parseInt(
						`${canvas['component_bottom_margin']}`
					);
				}

				if (canvas['component_top_margin']) {
					margin.marginTop = parseInt(
						`${canvas['component_top_margin']}`
					);
				}

				return margin;
			default:
				return margin;
		}
	} catch (e) {
		return margin;
	}
}

export function getCanvasStyle(style) {
	if (!style || !style['canvas']) {
		return {};
	}

	style = style['canvas'];
	const unit = style['canvas_unit'];

	return {
		marginBottom: style['component_bottom_margin']
			? `${style['component_bottom_margin']}px`
			: undefined,
		paddingTop: style['canvas-padding-top']
			? `${style['canvas-padding-top']}${unit}`
			: undefined,
		paddingBottom: style['canvas-padding-bottom']
			? `${style['canvas-padding-bottom']}${unit}`
			: undefined,
		paddingLeft: style['canvas-left-padding']
			? `${style['canvas-left-padding']}${unit}`
			: undefined,
		paddingRight: style['canvas-right-padding']
			? `${style['canvas-right-padding']}${unit}`
			: undefined,
		bodyColor: style['body-color']
			? `#${style['body-color'].replace('#', '')}`
			: '#ffffff',
		canvasColor: style['color']
			? `#${style['color'].replace('#', '')}`
			: '#ffffff',
		marginTop: style['canvas-margin-top']
			? `${style['canvas-margin-top']}${unit}`
			: undefined,
	};
}

export function processInlineStyles(component, styleComponent) {
	if (component.component === 'columns') {
		processColumnInlineStyles(component, styleComponent);
		return;
	}

	for (let style of component.styles) {
		const { properties } = style;
		if (!properties) {
			continue;
		}

		const props = properties[component.component];

		if (!props) {
			continue;
		}
		const {
			color,
			font_family,
			font_size,
			font_style,
			text_decoration,
			font_weight,
			text_align,
			text_transform,
			line_height,
			letter_spacing,
			margin_bottom,
			margin_top,
			padding_left,
			padding_right,
			padding_top,
			padding_bottom,
			font_family_bold,
			font_family_italic,
			font_family_bold_italic,
			background_color,
			background_color_enabled,
			text_display,
			dropcap_font_size,
			dropcap_line_height,
			dropcap_padding_right,
			dropcap_color,
			dropcap_margin_top,
		} = props;
		if (color) {
			styleComponent.color = `#${color.replace('#', '')}`;
		}
		if (font_family) {
			styleComponent.fontFamily = `${font_family}`;
		}

		if (text_display) {
			styleComponent.textDisplay = `${text_display}`;
		}
		if (font_family_bold) {
			styleComponent.fontFamilyBold = `${font_family_bold}`;
		}
		if (font_family_italic) {
			styleComponent.fontFamilyItalic = `${font_family_italic}`;
		}
		if (font_family_bold_italic) {
			styleComponent.fontFamilyBoldItalic = `${font_family_bold_italic}`;
		}
		if (font_size) {
			styleComponent.fontSize = `${font_size}em`;
		}
		if (font_style) {
			styleComponent.fontStyle = font_style;
		}
		if (text_decoration) {
			styleComponent.textDecoration = text_decoration;
		}
		if (font_weight) {
			styleComponent.fontWeight = font_weight;
		}
		if (text_align) {
			styleComponent.textAlign = text_align;
		}
		if (text_transform) {
			styleComponent.textTransform = text_transform;
		}
		if (line_height) {
			styleComponent.lineHeight = parseFloat(`${line_height}`);
		}
		if (letter_spacing) {
			styleComponent.letterSpacing = `${letter_spacing}em`;
		}
		if (dropcap_font_size) {
			styleComponent.dropcapFontSize = `${letter_spacing}em`;
		}
		if (dropcap_line_height) {
			styleComponent.dropcapLineHeight = `${dropcap_line_height}`;
		}
		if (dropcap_padding_right) {
			styleComponent.dropcapPaddingRight = `${dropcap_padding_right} px`;
		}
		if (dropcap_color) {
			styleComponent.dropcapColor = `#${dropcap_color.replace('#', '')}`;
		}
		if (dropcap_margin_top) {
			styleComponent.dropcapMarginTop = `${dropcap_margin_top} px`;
		}
		if (margin_bottom) {
			styleComponent.marginBottom = `${Math.ceil(
				parseFloat(`${margin_bottom}`)
			)}px`;
		}
		if (margin_top) {
			styleComponent.marginBottom = `${Math.ceil(
				parseFloat(`${margin_top}`)
			)}px`;
		}

		if (padding_left) {
			styleComponent.paddingLeft = `${padding_left}%`;
		}

		if (padding_top) {
			styleComponent.paddingTop = `${padding_top}%`;
		}

		if (padding_bottom) {
			styleComponent.paddingBottom = `${padding_bottom}%`;
		}

		if (
			background_color_enabled &&
			background_color_enabled === 'on' &&
			background_color
		) {
			styleComponent.background = `#${background_color.replace('#', '')}`;
		}

		if (padding_right) {
			styleComponent.paddingRight = `${padding_right}%`;
		}

		if (
			props['border_edge'] &&
			props['border_width'] &&
			props['border_type'] &&
			props.color
		) {
			const border = `${props['border_width']}px ${
				props['border_type']
			} ${props?.color ? `#${props.color.replace('#', '')}` : '#000000'}`;
			switch (props['border_edge']) {
				case 'top':
					styleComponent.borderTop = border;
					break;
				case 'left':
					styleComponent.borderLeft = border;
					break;
				case 'bottom':
					styleComponent.borderBottom = border;
					break;
				case 'right':
					styleComponent.borderRight = border;
					break;
				case 'top-bottom':
					styleComponent.borderTop = border;
					styleComponent.borderBottom = border;
					break;
				case 'left-bottom':
					styleComponent.borderTop = border;
					styleComponent.borderLeft = border;
					break;
				default:
					styleComponent.border = null;
			}
		}
	}
}

function processColumnInlineStyles(component, styleComponent) {
	for (let style of component.styles) {
		const { properties } = style;
		if (!properties) {
			continue;
		}

		for (const prop in properties) {
			if (Array.isArray(properties[prop])) {
				continue;
			}

			if (!styleComponent[prop]) {
				styleComponent[prop] = {};
			}

			const {
				color,
				font_family,
				font_size,
				font_style,
				text_decoration,
				font_weight,
				text_align,
				text_transform,
				line_height,
				letter_spacing,
				margin_bottom,
				margin_top,
				padding_left,
				padding_right,
				font_family_bold,
				font_family_italic,
				font_family_bold_italic,
				text_display,
				dropcap_font_size,
				dropcap_line_height,
				dropcap_padding_right,
				dropcap_color,
				dropcap_margin_top,
			} = properties[prop];
			if (color) {
				styleComponent[prop].color = `#${color.replace('#', '')}`;
			}

			if (text_display) {
				styleComponent[prop].textDisplay = `${text_display}`;
			}

			if (font_family) {
				styleComponent[prop].fontFamily = `${font_family}`;
			}
			if (font_family_bold) {
				styleComponent.fontFamilyBold = `${font_family_bold}`;
			}
			if (font_family_italic) {
				styleComponent.fontFamilyItalic = `${font_family_italic}`;
			}
			if (font_family_bold_italic) {
				styleComponent.fontFamilyBoldItalic = `${font_family_bold_italic}`;
			}
			if (font_size) {
				styleComponent[prop].fontSize = `${font_size}em`;
			}
			if (font_style) {
				styleComponent[prop].fontStyle = font_style;
			}
			if (text_decoration) {
				styleComponent[prop].textDecoration = text_decoration;
			}
			if (font_weight) {
				styleComponent[prop].fontWeight = font_weight;
			}
			if (text_align) {
				styleComponent[prop].textAlign = text_align;
			}
			if (text_transform) {
				styleComponent[prop].textTransform = text_transform;
			}
			if (line_height) {
				styleComponent[prop].lineHeight = parseFloat(`${line_height}`);
			}
			if (letter_spacing) {
				styleComponent[prop].letterSpacing = `${letter_spacing}em`;
			}
			if (margin_bottom) {
				styleComponent[prop].marginBottom = `${Math.ceil(
					parseFloat(`${margin_bottom}`)
				)}px`;
			}
			if (margin_top) {
				styleComponent[prop].marginBottom = `${Math.ceil(
					parseFloat(`${margin_top}`)
				)}px`;
			}

			if (padding_left) {
				styleComponent[prop].paddingLeft = `${padding_left}%`;
			}

			if (padding_right) {
				styleComponent[prop].paddingRight = `${padding_right}%`;
			}

			if (dropcap_font_size) {
				styleComponent[prop].dropcapFontSize = `${letter_spacing}em`;
			}
			if (dropcap_line_height) {
				styleComponent[
					prop
				].dropcapLineHeight = `${dropcap_line_height}`;
			}
			if (dropcap_padding_right) {
				styleComponent[
					prop
				].dropcapPaddingRight = `${dropcap_padding_right} px`;
			}
			if (dropcap_color) {
				styleComponent[prop].dropcapColor = `#${dropcap_color.replace(
					'#',
					''
				)}`;
			}
			if (dropcap_margin_top) {
				styleComponent.dropcapMarginTop = `${dropcap_margin_top} px`;
			}

			if (
				properties[prop]['border_edge'] &&
				properties[prop]['border_width'] &&
				properties[prop]['border_type'] &&
				color
			) {
				const border = `${properties[prop]['border_width']}px ${
					properties[prop]['border_type']
				} ${
					properties[prop]?.color
						? `#${properties[prop].color.replace('#', '')}`
						: '#000000'
				}`;
				switch (properties[prop]['border_edge']) {
					case 'top':
						styleComponent[prop].borderTop = border;
						break;
					case 'left':
						styleComponent[prop].borderLeft = border;
						break;
					case 'bottom':
						styleComponent[prop].borderBottom = border;
						break;
					case 'right':
						styleComponent[prop].borderRight = border;
						break;
					case 'top-bottom':
						styleComponent[prop].borderTop = border;
						styleComponent[prop].borderBottom = border;
						break;
					case 'left-bottom':
						styleComponent[prop].borderTop = border;
						styleComponent[prop].borderLeft = border;
						break;
					default:
						styleComponent[prop].border = null;
				}
			}
		}
	}
}

export function getStyle(name, style, styleblock) {
	if (!!styleblock && !!style) {
		style = { ...style, ...styleblock };
	}

	if (!style || !style[name]) {
		return {};
	}

	style = style[name];
	console.log(`STYLE for ${name}`);
	console.log(style);
	const response = {
		color: style?.color ? `#${style.color.replace('#', '')}` : '#000000',
		fontFamily: style['font_family'],
		fontSize: style['font_size'] ? `${style['font_size']}em` : undefined,
		fontStyle: style['font_style'],
		fontWeight: style['font_weight'],
		letterSpacing: style['letter_spacing']
			? `${style['letter_spacing']}em`
			: undefined,
		lineHeight: style['line_height']
			? `${style['line_height']}`
			: undefined,
		textAlign: style['text_align'],
		textDecoration: style['text_decoration'],
		textTransform: style['text_transform'],
		width: '100%',
		textDisplay: style['text_display'],
	};

	if (style['padding_left']) {
		response.paddingLeft = `${style['padding_left']}%`;
	}

	if (style['padding_right']) {
		response.paddingRight = `${style['padding_right']}%`;
	}

	if (style['padding_top']) {
		response.paddingTop = `${style['padding_top']}%`;
	}

	if (style['padding_bottom']) {
		response.paddingBottom = `${style['padding_bottom']}%`;
	}

	if (style['font_family_bold']) {
		response.fontFamilyBold = `${style['font_family_bold']}`;
	}

	if (
		style['background_color_enabled'] &&
		style['background_color_enabled'] === 'on' &&
		style['background_color']
	) {
		response.background = style['background_color'];
	}

	if (style['font_family_italic']) {
		response.fontFamilyItalic = `${style['font_family_italic']}`;
	}

	if (style['font_family_bold_italic']) {
		response.fontFamilyBoldItalic = `${style['font_family_bold_italic']}`;
	}

	if (style['dropcap_font_size']) {
		response.dropcapFontSize = `${style['dropcap_font_size']}em`;
	}
	if (style['dropcap_line_height']) {
		response.dropcapLineHeight = `${style['dropcap_line_height']}`;
	}
	if (style['dropcap_padding_right']) {
		response.dropcapPaddingRight = `${style['dropcap_padding_right']}px`;
	}
	if (style['dropcap_color']) {
		response.dropcapColor = `#${style['dropcap_color'].replace('#', '')}`;
	}
	if (style['dropcap_margin_top']) {
		response.dropcapMarginTop = `${style['dropcap_margin_top']}px`;
	}

	if (
		style['border_edge'] &&
		style['border_width'] &&
		style['border_type'] &&
		style.color
	) {
		const border = `${style['border_width']}px ${style['border_type']} ${
			style?.color ? `#${style.color.replace('#', '')}` : '#000000'
		}`;
		switch (style['border_edge']) {
			case 'top':
				response.borderTop = border;
				break;
			case 'left':
				response.borderLeft = border;
				break;
			case 'bottom':
				response.borderBottom = border;
				break;
			case 'right':
				response.borderRight = border;
				break;
			case 'top-bottom':
				response.borderTop = border;
				response.borderBottom = border;
				break;
			case 'left-bottom':
				response.borderTop = border;
				response.borderLeft = border;
				break;
			default:
				response.border = null;
		}
	}

	if (style['margin_bottom']) {
		response.marginBottom = `${Math.ceil(
			parseFloat(`${style['margin_bottom']}`)
		)}px`;
	}

	if (style['margin_top']) {
		response.marginTop = `${Math.ceil(
			parseFloat(`${style['margin_top']}`)
		)}px`;
	}

	for (const k in response) {
		if (response[k] === undefined) {
			delete response[k];
		}
	}

	return response;
}

export function overwriteStyles(style, overwrite) {
	const response = {};
	const properties = { ...style, ...overwrite };
	for (const property in properties) {
		if (style[property] && overwrite[property]) {
			response[property] = { ...style[property], ...overwrite[property] };
		}

		if (overwrite[property] && !style[property]) {
			response[property] = overwrite[property];
		}

		if (!overwrite[property] && style[property]) {
			response[property] = style[property];
		}
	}
	return response;
}

export function mapStyleProperties(properties) {
	const style = {};

	if (properties['font_family']) {
		style.fontFamily = properties['font_family'];
	}

	if (properties['text_display']) {
		style.textDisplay = properties['text_display'];
	}

	if (properties['font_family_bold']) {
		style.fontFamilyBold = properties['font_family_bold'];
	}

	if (properties['font_family_italic']) {
		style.fontFamilyItalic = properties['font_family_italic'];
	}

	if (properties['font_family_bold_italic']) {
		style.fontFamilyBoldItalic = properties['font_family_bold_italic'];
	}

	if (properties['color']) {
		style.color = `#${properties['color'].replace('#', '')}`;
	}

	if (properties['font_size']) {
		style.fontSize = `${properties['font_size']}em`;
	}

	if (properties['font_style']) {
		style.fontStyle = properties['font_style'];
	}

	if (properties['font_weight']) {
		style.fontWeight = properties['font_weight'];
	}

	if (properties['letter_spacing']) {
		style.letterSpacing = `${properties['letter_spacing']}em`;
	}

	if (properties['line_height']) {
		style.lineHeight = properties['line_height'];
	}

	if (properties['text_align']) {
		style.textAlign = properties['text_align'];
	}

	if (
		properties['text_decoration'] &&
		properties['text_decoration'] !== 'none'
	) {
		style.textDecoration = properties['text_decoration'];
	}

	if (properties['text_transform']) {
		style.textTransform = properties['text_transform'];
	}

	if (properties['margin_bottom']) {
		style.marginBottom = `${Math.ceil(
			parseFloat(`${properties['margin_bottom']}`)
		)}px`;
	}

	if (properties['margin_top']) {
		style.marginTop = `${Math.ceil(
			parseFloat(`${properties['margin_top']}`)
		)}px`;
	}

	if (properties['dropcap_font_size']) {
		style.dropcapFontSize = `${properties['dropcap_font_size']}em`;
	}
	if (properties['dropcap_line_height']) {
		style.dropcapLineHeight = `${properties['dropcap_line_height']}`;
	}
	if (properties['dropcap_padding_right']) {
		style.dropcapPaddingRight = `${properties['dropcap_padding_right']} px`;
	}
	if (properties['dropcap_color']) {
		style.dropcapColor = `#${properties['dropcap_color'].replace('#', '')}`;
	}
	if (properties['dropcap_margin_top']) {
		style.dropcapMarginTop = `${properties['dropcap_margin_top']} px`;
	}

	if (
		properties['border_edge'] &&
		properties['border_width'] &&
		properties['border_type'] &&
		properties.color
	) {
		const border = `${properties['border_width']}px ${
			properties['border_type']
		} ${
			properties?.color
				? `#${properties.color.replace('#', '')}`
				: '#000000'
		}`;
		switch (properties['border_edge']) {
			case 'top':
				style.borderTop = border;
				break;
			case 'left':
				style.borderLeft = border;
				break;
			case 'bottom':
				style.borderBottom = border;
				break;
			case 'right':
				style.borderRight = border;
				break;
			case 'top-bottom':
				style.borderTop = border;
				style.borderBottom = border;
				break;
			case 'left-bottom':
				style.borderTop = border;
				style.borderLeft = border;
				break;
			default:
				style.border = null;
		}
	}

	return style;
}

export function getDeviceType({ deviceWidth }) {
	return deviceWidth < 769
		? 'mobile'
		: deviceWidth < 1199
		? 'tablet'
		: 'desktop';
}

export function getGridTemplate({ colsplit, columns }) {
	if (typeof colsplit === 'number') {
		return columns.map(() => `${colsplit}%`).join(' ');
	}

	const split = colsplit.split('-');
	if (typeof colsplit === 'string' && !!split.length) {
		return split.map((value) => `${value}%`).join(' ');
	}

	return `${columns.map(() => '1fr').join(' ')}`;
}
